import React, { useEffect, useMemo } from 'react';
import { Tag } from "antd";

import { RightSidebar } from "../../../_partials/Layout";
import { DeviceInterface } from "../../../../store/mine_craft/devicesSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchBannedIps } from "../../../../actions/mine_craft/bannedIpsActions";
import RowInfo from "../../../../componets/RowInfo";
import { formattedDate } from "../../../../helpers/DateHelpers";
import {boolToText} from "../../../../helpers/TextHelpers";

const _SidebarShow = ({ device }: { device: DeviceInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const bannedIpEntities = useAppSelector(state => state.mineCraft.bannedIps.entities);
  const bannedIpIds      = useAppSelector(state => state.mineCraft.bannedIps.ids);

  useEffect(() => {
    if (device) {
      dispatch(fetchBannedIps({ active: 'true' }));
    }
  }, [device, dispatch]);

  const bannedIpSet = useMemo(() => {
    const set = new Set<string>();
    if (bannedIpIds) {
      bannedIpIds.forEach(id => {
        const entry = bannedIpEntities[id];
        if (entry?.ip) set.add(entry.ip);
      });
    }
    return set;
  }, [bannedIpIds, bannedIpEntities]);

  const renderIp = (ip: string | null) => {
    if (!ip) return '—';
    if (bannedIpSet.has(ip)) {
      return <>{ip} <Tag color="error">Banned</Tag></>;
    }
    return ip;
  };

  // app_attest = Apple App Attest; device_key = the weaker AppTransaction-gated
  // fallback for iOS apps on Macs. Absent for v1-only and Android devices.
  const renderAttestation = () => {
    if (!device?.attestation_kind) return '—';

    const strong = device.attestation_kind === 'app_attest';
    return <Tag color={strong ? 'green' : 'orange'}>{strong ? 'App Attest' : 'Device Key'}</Tag>;
  };

  const renderDetails = () => {
    if(!device) {
      return null;
    }

    const banned  = device.banned_until ? formattedDate(device.banned_until).dateTime : '';
    const launch  = device.launch_at ? formattedDate(device.launch_at).dateTime : '';

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={device.id} />
          <RowInfo left='Coins' right={device.coins} />
          <RowInfo left='Bundle Name' right={device.bundle?.name} />
          <RowInfo left='VendorID' right={device.vendor} />
          <RowInfo left='Attestation' right={renderAttestation()} />
          <RowInfo left='Last Ban' right={banned} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Network</h6>

          <RowInfo left='Current IP' right={renderIp(device.ip)} />
          <RowInfo left='Last IP'    right={renderIp(device.last_ip)} />
          <RowInfo left='Create IP'  right={renderIp(device.create_ip)} />
          <RowInfo left='Launch Count' right={device.launch_count} />
          <RowInfo left='Launch At'    right={launch} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Active ADs</h6>

          <RowInfo left='Banner' right={boolToText(device.banner)} />
          <RowInfo left='Native Ads' right={boolToText(device.native_ads)} />
          <RowInfo left='App Open' right={boolToText(device.app_open)} />
          <RowInfo left='Interstitial' right={boolToText(device.interstitial)} />
          <RowInfo left='Interstitial Long' right={boolToText(device.interstitial_long)} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Notify Information</h6>

          <RowInfo left='Timezone' right={device.timezone} />
          <RowInfo left='Language' right={device.language} />
          <RowInfo left='Country code' right={device.country_code} />
          <RowInfo left='Device type' right={device.device_type} />
          <RowInfo left='OS Version' right={device.os_version} />
          <RowInfo left='Notify Token' right={device.notify_token} />
        </div>

        <div>
          <h6 className='v-content-label o-sm'>Notifications</h6>

          <RowInfo left='Youtube video' right={boolToText(device.notify_youtube_video)} />
          <RowInfo left='App update' right={boolToText(device.notify_app_update)} />
          <RowInfo left='Daily rewards' right={boolToText(device.notify_daily_rewards)} />
          <RowInfo left='Step YoutubeVideo' right={device.step_youtube_video} />
          <RowInfo left='Step app update' right={device.step_app_update} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
